import React from 'react'
import  {TextHighlight} from '../../components';
import {VisDiv} from '../../components';
import {useStateContext} from '../../context/StateContext';



/**
 * A component that displays a label and a value in a div container.
 * It also takes optional props to customize the style of the label and value.
 * #deviceFields
 *  #core
 * 
 * @param {string} label - the label to display
 * @param {string} value - the value to display
 * @param {string} labelColor - the color of the label
 * @param {string} valueColor - the color of the value
 * @param {boolean} boldValue - whether to display the value in bold
 * @param {boolean} boldLabel - whether to display the label in bold
 * @param {string} highlight - the highlight color of the value
 * @param {boolean} noBorder - whether to display a border around the container
 * @param {number} labelValueDistance - the distance between the label and value
 * @param {ReactNode} children - the children to render inside the container
 */
const ViewLabelValueField = ({label, value, labelColor, valueColor, boldValue, boldLabel, highlight, noBorder, labelValueDistance, children}) => {

  const {LDB} = useStateContext()
  const labelFlex = labelValueDistance ? {flex:1} : {flex:1}
  const valueFlex = labelValueDistance ? {flex: labelValueDistance} : {flex:1.3}
  const traslateLabel = () => {
    if(label=="SCADENZA ESERCIZIO") return LDB("fields","assetExpiry")
    return label
}
const border = noBorder ? "vlfield-container-no-border" : "vlfield-container" 

  return (
    <div className = {border}>
        <VisDiv rules={[label]} className='vlfield-label-container' style={{color:labelColor, ...labelFlex}}>
          {
            !boldLabel ? `${traslateLabel()}:` : <h3>{traslateLabel()}:</h3>
          }
           
        </VisDiv>
        <div className='vlfield-value-container' style={{color:valueColor, ...valueFlex}}>
          {
            !boldValue ? 
            <TextHighlight highlight={highlight}>
              {value}
           </TextHighlight> :
            <TextHighlight highlight={highlight} boldValue>
                {value}
            </TextHighlight>
          }
             {children}

        </div> 
    </div>
  )
}

export default ViewLabelValueField
